import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, MaskRevealInView } from "../components/Reveal";
import { PROCESS, CREDENTIALS, IMAGES } from "../data";

export default function WorkWithMe() {
  return (
    <>
      <section className="pt-36 md:pt-48 pb-16 md:pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <Reveal>
            <p className="font-sans text-[11px] tracking-[0.4em] uppercase text-rosedeep mb-10">
              Work With Me — The process
            </p>
          </Reveal>
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <h1 className="lg:col-span-8 font-serif text-5xl sm:text-6xl lg:text-8xl leading-[0.98] text-ink tracking-tight">
              <MaskRevealInView lines={["A clear, practical", "path to"]} />
              <span className="italic font-display text-rosedeep">
                <MaskRevealInView lines={["sustainable growth."]} delay={0.2} />
              </span>
            </h1>
            <Reveal delay={0.2} className="lg:col-span-4">
              <p className="font-sans text-lg leading-relaxed text-mutedfg">
                A considered, four-step approach that combines strategic thinking with creative execution — built around your business and your goals.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Process timeline */}
      <section className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 pb-20 md:pb-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-borderwarm border border-borderwarm">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={(i % 4) * 0.08} className="bg-white">
              <div className="h-full p-8 lg:p-10">
                <span className="font-serif text-6xl md:text-7xl text-rose">{p.n}</span>
                <h3 className="mt-6 font-serif text-2xl md:text-3xl text-ink">{p.title}</h3>
                <p className="mt-4 font-sans text-sm leading-relaxed text-mutedfg">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Why work with me */}
      <section className="bg-wine text-blush py-24 md:py-36">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <Reveal>
            <p className="font-sans text-[11px] tracking-[0.35em] uppercase text-rose mb-6">Why Work With Me</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-none text-white mb-14 md:mb-20 max-w-2xl">
              Credibility, care and a strategic approach.
            </h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6">
            {CREDENTIALS.map((c, i) => (
              <Reveal key={c} delay={(i % 2) * 0.06}>
                <div className="flex items-start gap-4 border-t border-white/15 pt-5">
                  <Check size={18} className="mt-1 shrink-0 text-rose" />
                  <p className="font-serif text-xl md:text-2xl leading-snug text-white">{c}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="relative overflow-hidden aspect-[4/5] bg-blush">
              <img src={IMAGES.grad} alt="Roisin Doyle" className="h-full w-full object-cover object-top" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl md:text-6xl text-ink leading-tight text-balance">
              Let's build something <span className="italic font-display text-rosedeep">meaningful.</span>
            </h2>
            <p className="mt-6 font-sans text-lg text-mutedfg leading-relaxed max-w-lg">
              Every partnership starts with a conversation. Get in touch and let's talk about where you want to grow.
            </p>
            <Link
              to="/contact"
              data-testid="wwm-cta"
              className="group inline-flex items-center gap-3 mt-10 rounded-full bg-rosedeep text-white px-8 py-4 font-sans text-[12px] tracking-[0.16em] uppercase transition-colors duration-300 hover:bg-ink"
            >
              Get In Touch
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
